import { Experiments } from '../types';
import { WixCodeApi, WixExperiments } from '../types/controller';

export const requestLogin = (
  wixCodeApi: WixCodeApi,
  experiments?: WixExperiments,
) => {
  wixCodeApi.user.promptLogin({ modal: true }).catch(() => {});
};
